import { Input } from '../ui/input';

type TEmailProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const Email = ({ value, onChange }: TEmailProps) => (
  <Input
    placeholder='name@example.com'
    type='email'
    value={value}
    onChange={onChange}
  />
);

export default Email;
